export default {
  buttons: {
    confirm: {
      'zh-cn': '确认',
      'zh-tw': '確認',
      'en': 'Confirm'
    },
    cancel: {
      'zh-cn': '取消',
      'zh-tw': '取消',
      'en': 'Cancel'
    },
    submit: {
      'zh-cn': '提交',
      'zh-tw': '提交',
      'en': 'Submit'
    },
    reset: {
      'zh-cn': '重置',
      'zh-tw': '重置',
      'en': 'Reset'
    },
    search: {
      'zh-cn': '搜索',
      'zh-tw': '搜索',
      'en': 'Search'
    },
    add: {
      'zh-cn': '新增',
      'zh-tw': '新增',
      'en': 'Add'
    },
    edit: {
      'zh-cn': '编辑',
      'zh-tw': '編輯',
      'en': 'Edit'
    },
    delete: {
      'zh-cn': '删除',
      'zh-tw': '刪除',
      'en': 'Delete'
    },
    export: {
      'zh-cn': '导出',
      'zh-tw': '導出',
      'en': 'Export'
    },
    import: {
      'zh-cn': '导入',
      'zh-tw': '導入',
      'en': 'Import'
    },
    save: {
      'zh-cn': '保存',
      'zh-tw': '保存',
      'en': 'Save'
    },
    close: {
      'zh-cn': '关闭',
      'zh-tw': '關閉',
      'en': 'Close'
    },
    back: {
      'zh-cn': '返回',
      'zh-tw': '返回',
      'en': 'Back'
    },
    next: {
      'zh-cn': '下一步',
      'zh-tw': '下一步',
      'en': 'Next'
    },
    prev: {
      'zh-cn': '上一步',
      'zh-tw': '上一步',
      'en': 'Previous'
    },
    upload: {
      'zh-cn': '上传',
      'zh-tw': '上傳',
      'en': 'Upload'
    },
    download: {
      'zh-cn': '下载',
      'zh-tw': '下載',
      'en': 'Download'
    },
    view: {
      'zh-cn': '查看',
      'zh-tw': '查看',
      'en': 'View'
    },
    refresh: {
      'zh-cn': '刷新',
      'zh-tw': '刷新',
      'en': 'Refresh'
    }
  },
  messages: {
    success: {
      'zh-cn': '操作成功',
      'zh-tw': '操作成功',
      'en': 'Operation successful'
    },
    error: {
      'zh-cn': '操作失败',
      'zh-tw': '操作失敗',
      'en': 'Operation failed'
    },
    warning: {
      'zh-cn': '警告',
      'zh-tw': '警告',
      'en': 'Warning'
    },
    info: {
      'zh-cn': '提示',
      'zh-tw': '提示',
      'en': 'Info'
    },
    confirmTitle: {
      'zh-cn': '确认',
      'zh-tw': '確認',
      'en': 'Confirm'
    },
    deleteConfirm: {
      'zh-cn': '确定要删除吗？',
      'zh-tw': '確定要刪除嗎？',
      'en': 'Are you sure you want to delete?'
    },
    saveSuccess: {
      'zh-cn': '保存成功',
      'zh-tw': '保存成功',
      'en': 'Save successful'
    },
    deleteSuccess: {
      'zh-cn': '删除成功',
      'zh-tw': '刪除成功',
      'en': 'Delete successful'
    },
    updateSuccess: {
      'zh-cn': '更新成功',
      'zh-tw': '更新成功',
      'en': 'Update successful'
    },
    addSuccess: {
      'zh-cn': '添加成功',
      'zh-tw': '添加成功',
      'en': 'Add successful'
    },
    operationSuccess: {
      'zh-cn': '操作成功',
      'zh-tw': '操作成功',
      'en': 'Operation successful'
    },
    operationFailed: {
      'zh-cn': '操作失败',
      'zh-tw': '操作失敗',
      'en': 'Operation failed'
    },
    requestFailed: {
      'zh-cn': '请求失败',
      'zh-tw': '請求失敗',
      'en': 'Request failed'
    },
    noData: {
      'zh-cn': '暂无数据',
      'zh-tw': '暫無數據',
      'en': 'No data'
    },
    loading: {
      'zh-cn': '加载中...',
      'zh-tw': '加載中...',
      'en': 'Loading...'
    },
    pleaseSelect: {
      'zh-cn': '请选择',
      'zh-tw': '請選擇',
      'en': 'Please select'
    },
    pleaseInput: {
      'zh-cn': '请输入',
      'zh-tw': '請輸入',
      'en': 'Please input'
    }
  },
  validation: {
    required: {
      'zh-cn': '此项为必填项',
      'zh-tw': '此項為必填項',
      'en': 'This field is required'
    },
    pleaseInput: {
      'zh-cn': '请输入',
      'zh-tw': '請輸入',
      'en': 'Please input'
    },
    pleaseSelect: {
      'zh-cn': '请选择',
      'zh-tw': '請選擇',
      'en': 'Please select'
    },
    invalidFormat: {
      'zh-cn': '格式不正确',
      'zh-tw': '格式不正確',
      'en': 'Invalid format'
    },
    minLength: {
      'zh-cn': '最小长度为{min}个字符',
      'zh-tw': '最小長度為{min}個字符',
      'en': 'Minimum length is {min} characters'
    },
    maxLength: {
      'zh-cn': '最大长度为{max}个字符',
      'zh-tw': '最大長度為{max}個字符',
      'en': 'Maximum length is {max} characters'
    },
    passwordMinLength: {
      'zh-cn': '密码最小长度6个字符',
      'zh-tw': '密碼最小長度6個字符',
      'en': 'Password minimum length is 6 characters'
    },
    passwordMaxLength: {
      'zh-cn': '密码最大长度32个字符',
      'zh-tw': '密碼最大長度32個字符',
      'en': 'Password maximum length is 32 characters'
    },
    passwordNotMatch: {
      'zh-cn': '两次密码输入不一致',
      'zh-tw': '兩次密碼輸入不一致',
      'en': 'The two passwords do not match'
    },
    accountMaxLength: {
      'zh-cn': '账号最大长度32个字符',
      'zh-tw': '賬號最大長度32個字符',
      'en': 'Account maximum length is 32 characters'
    },
    accountMustNumber: {
      'zh-cn': '请输入数字',
      'zh-tw': '請輸入數字',
      'en': 'Please enter a number'
    },
    fileSizeLimit: {
      'zh-cn': '文件大小控制在{max}M以内',
      'zh-tw': '文件大小控制在{max}M以內',
      'en': 'File size must be within {max}M'
    }
  },
  labels: {
    account: {
      'zh-cn': '账号',
      'zh-tw': '賬號',
      'en': 'Account'
    },
    password: {
      'zh-cn': '密码',
      'zh-tw': '密碼',
      'en': 'Password'
    },
    oldPassword: {
      'zh-cn': '旧密码',
      'zh-tw': '舊密碼',
      'en': 'Old Password'
    },
    newPassword: {
      'zh-cn': '新密码',
      'zh-tw': '新密碼',
      'en': 'New Password'
    },
    confirmPassword: {
      'zh-cn': '确认密码',
      'zh-tw': '確認密碼',
      'en': 'Confirm Password'
    },
    username: {
      'zh-cn': '用户名',
      'zh-tw': '用戶名',
      'en': 'Username'
    },
    phone: {
      'zh-cn': '手机号',
      'zh-tw': '手機號',
      'en': 'Phone'
    },
    email: {
      'zh-cn': '邮箱',
      'zh-tw': '郵箱',
      'en': 'Email'
    },
    company: {
      'zh-cn': '所属企业',
      'zh-tw': '所屬企業',
      'en': 'Company'
    },
    employeeName: {
      'zh-cn': '员工姓名',
      'zh-tw': '員工姓名',
      'en': 'Employee Name'
    },
    version: {
      'zh-cn': '版本',
      'zh-tw': '版本',
      'en': 'Version'
    },
    status: {
      'zh-cn': '状态',
      'zh-tw': '狀態',
      'en': 'Status'
    },
    createTime: {
      'zh-cn': '创建时间',
      'zh-tw': '創建時間',
      'en': 'Create Time'
    },
    updateTime: {
      'zh-cn': '更新时间',
      'zh-tw': '更新時間',
      'en': 'Update Time'
    },
    description: {
      'zh-cn': '描述',
      'zh-tw': '描述',
      'en': 'Description'
    },
    remark: {
      'zh-cn': '备注',
      'zh-tw': '備註',
      'en': 'Remark'
    },
    operation: {
      'zh-cn': '操作',
      'zh-tw': '操作',
      'en': 'Operation'
    },
    select: {
      'zh-cn': '选择',
      'zh-tw': '選擇',
      'en': 'Select'
    },
    all: {
      'zh-cn': '全部',
      'zh-tw': '全部',
      'en': 'All'
    }
  }
}

